<template>
    <div class="client-app slot" style="margin-top:10px">
        <div class="client-app-inc" style="height:200px" v-if="isLoading">
          <Loader style="margin-top:-40px"></Loader>
        </div>
        <div class="client-app-inc" v-show="!inPlay && !isLoading"> 
            <div class="casino-center" style="width:100%" v-if="!isMobile">
                  <div class="container">
                    <Slider :inPlay="inPlay" :isLoadingParent="isLoading"/>
                    <GameSlider :inPlay="inPlay" :isLoadingParent="isLoading"/>
                    <MobileHeader/>
                    <Categories/>
                    <Games @loginModal="loginModal = $event"/>
                  </div>
            </div>
            <div class="app-casino-mobile"  v-if="isMobile">
                <div>
                  <Slider :inPlay="inPlay" :isLoadingParent="isLoading"/>
                  <GameSlider :inPlay="inPlay" :isLoadingParent="isLoading"/>
                  <MobileHeader/>
                  <Categories @menuChange="mobile_menu = $event" :mobile_menu="mobile_menu"/>
                  <Search/>
                </div>
                <div class="casino-content">
                  <Games @loginModal="loginModal = $event" v-show="mobile_menu == 'games' || mobile_menu == 'fav'"/>
                  <FavGames @loginModal="loginModal = $event" v-show="mobile_menu == 'favGames'"></FavGames>
                </div>
            </div>
        </div>
        <div class="client-app-inc" v-if="inPlay">
            <GameWindow/>
        </div>
        <Modal class="casino-login-modal" @modalStatus="loginModal = $event" :isVisible="loginModal && !$auth()">
          <template slot="content">
              <UserLogin/>
          </template>
        </Modal>
    </div>
</template>
<script>
  import LeftSide from '../../components/Slot/LeftSide'
  import Slider from '../../components/Slot/Slider'
  import GameSlider from '../../components/Slot/GameSlider'
  import Categories from '../../components/Slot/Categories'
  import Providers from '../../components/Slot/Providers'
  import Games from '../../components/Slot/Games'
  import FavGames from '../../components/Slot/FavGames'
  import GameWindow from '../../components/Slot/GameWindow'
  import MobileHeader from '../../components/Slot/MobileHeader'
  import MobileMenu from '../../components/Slot/MobileMenu'
  import Search from '../../components/Slot/Search'
  import UserLogin from '../../views/Auth/Login'
  export default{
    name : 'SlotGames',
    data(){
      return{
        mobile_menu: 'games',
        isLoading: true,
        loginModal: false,
      }
    },
    computed:{
      inPlay(){
        return this.$store.getters['slot/getInPlay'];
      },
    },
    created(){
      this.fetchData();
    },
    methods:{
      fetchData(){
        this.isLoading = true;
        this.$store.dispatch('slot/initSlot')
        .then(response =>{
          this.isLoading = false;
          return response
        })
      }
    },
    watch:{
      loginModal(val){
        if(val){
          document.querySelector("#app").classList.add('lock');
        }else{
          document.querySelector("#app").classList.remove('lock');
        }
      }
    },
    components:{
      LeftSide,
      Providers,
      Categories,
      GameWindow,
      FavGames,
      MobileHeader,
      MobileMenu,
      Search,
      Games,
      Slider,
      GameSlider,
      UserLogin
    }
  }
</script>